<template>
  <div :class="['top', isScrolled ? 'scrolled' : 'not-scrolled']">
    <div class="nav w1200 clearIt">

      <div class="contact-icons01">
        <div class="contact-icon01" @click="active('/')" >
          <img src="./logo.png" >  <span style="position: absolute;color: white;font-size: 20px;margin-top: 0px;margin-left: 5px;">安贝森集团</span>
        </div>
      </div>

      <div class="menu-container" style="margin-left: 140px">
        <a-menu mode="horizontal">
          <a-menu-item class="a-menu-item" key="home" @click="active('/')" @mouseenter="show3 = false" >首页</a-menu-item>
          <a-menu-item class="a-menu-item" key="about" @click="active('/aboutsUs')" @mouseenter="show3 = false" >关于我们</a-menu-item>
          <a-menu-item class="a-menu-item" key="news" @click="active('/news')" @mouseenter="show3 = false" >企业动态</a-menu-item>
          <a-menu-item class="a-menu-item" key="news" @click="active('/productAndService')" @mouseenter="show3 = !show3"  >产品和服务</a-menu-item>
          <a-menu-item class="a-menu-item" key="contact" @click="active('/callMe')" @mouseenter="show3 = false" >联系我们</a-menu-item>
        </a-menu>
      </div>

      <div>
        <div style="margin-top: 25px; height: 200px;position: absolute;margin-left: 140px">
          <el-collapse-transition>
            <div v-show="show3">
              <div class="transition-box" @click="show3 = !show3">
                <p @click="active('/digitalsoftware')">数字化软件</p>
                <p @click="active('/intellectualProperty')">知识产权</p>
                <p @click="active('/parkServices')">园区服务</p>
                <p @click="active('/projectApplication')">项目申报</p>
                <p @click="active('/qualifications')">资质认定</p>
                <p @click="active('/financialAudit')">财务审计</p>
              </div>

            </div>
          </el-collapse-transition>
        </div>
      </div>

      <div class="contact-icons">
        <div class="contact-icon">
          <img :src="phoneImg1" alt="Phone" ref="phoneIcon">
          <div class="contact-tooltip-phone">总公司: 0718-8226099<br>分公司: 0718-8226099</div>
        </div>
        <div class="contact-icon">
          <img :src="qqImg2" alt="QQ" ref="qqImgIcon">
<!--          <div class="contact-tooltip-qq">QQ：982179235<br>邮箱: AbsScitech01@163.com</div>-->
          <div class="contact-tooltip-qq">邮箱: AbsScitech01@163.com</div>
        </div>
        <div class="contact-icon">
          <img :src="wxImg3" alt="WeChat" ref="wxImgIcon">
          <div class="contact-tooltip-weichat">
            <img src="../../assets/image/index/weichat7.png" alt="WeChat" style="width: 200px;height: 200px">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
@import './header.css';
@import '../css/common.css';
</style>
<script>
import {Menu} from 'ant-design-vue';
import subMenu from "ant-design-vue/lib/menu/SubMenu";
import CallMeDialog from '../../components/CallMeDialog.vue'
export default {
  name: 'headers',
  components: {
    'a-menu': Menu,
    'a-menu-item': Menu.Item,
    // 'a-sub-menu': subMenu,
    // 'a-menu-item-group': Menu.ItemGroup
  },
  data() {
    return {
      phoneImg1: require("../../assets/image/index/phone001.png"),
      qqImg2: require('../../assets/image/index/qq001.png'),
      wxImg3: require('../../assets/image/index/wx001.png'),
      show3: false,
      isScrolled: false, // 用于记录是否滚动
    }
  },
  mounted() {
    this.$nextTick(() => {
      const phoneIcon = this.$refs.phoneIcon;
      const qqImgIcon = this.$refs.qqImgIcon;
      const wxImgIcon = this.$refs.wxImgIcon;
      if (phoneIcon) {
        phoneIcon.addEventListener('mouseover', () => {
          this.phoneImg1 = require('../../assets/image/index/phone002.png');
        });
        phoneIcon.addEventListener('mouseout', () => {
          this.phoneImg1 = require('../../assets/image/index/phone001.png');
        });
      }
      if (qqImgIcon) {
        qqImgIcon.addEventListener('mouseover', () => {
          this.qqImg2 = require('../../assets/image/index/qq002.png');
        });
        qqImgIcon.addEventListener('mouseout', () => {
          this.qqImg2 = require('../../assets/image/index/qq001.png');
        });
      }
      if (wxImgIcon) {
        wxImgIcon.addEventListener('mouseover', () => {
          this.wxImg3 = require('../../assets/image/index/wx002.png');
        });
        wxImgIcon.addEventListener('mouseout', () => {
          this.wxImg3 = require('../../assets/image/index/wx001.png');
        });
      }
    });
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    active(url) {
      this.$router.push(url);
    },
    handleScroll() {
      // 获取页面滚动距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 判断是否滚动到顶部
      if (scrollTop > 0) {
        this.isScrolled = true; // 设置滚动状态为 true
        this.show3 = false; // 滚动隐藏下拉菜单
      } else {
        this.isScrolled = false; // 滚动到顶部时重置滚动状态
      }
    },
  },
  created: function () {

  }
}
</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/header/header.vue